import { Box } from "@chakra-ui/react";
import { useGetCicoKycStatusQuery } from "apis";
import { KycTitle, ModalView, ProgressIndicator } from "components";
import { PageProps } from "interfaces";

import { RegistrationForms } from "ui";

interface RegistrationProps extends PageProps {}

const CicoKYC = (props: RegistrationProps) => {
  const { data, isLoading } = useGetCicoKycStatusQuery({});

  return (
    <Box pt="16px">
      {!isLoading && (
        <ModalView>
          {data?.status === "KycApproved" ? (
            <Box textAlign="center" fontSize="18px" mt="24px" fontWeight="600">
              KYC Approved
            </Box>
          ) : (
            <>
              <KycTitle hideMore />

              <ProgressIndicator />

              <RegistrationForms {...props} />
            </>
          )}
        </ModalView>
      )}
    </Box>
  );
};

export default CicoKYC;
